// src/components/LoginForm.jsx
import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAlert } from "../components/CustomAlert";

function LoginForm({ switchLanguage }) {
  // ✅ 分开取命名空间，避免命名冲突
  const { t: tAuth } = useTranslation("auth");
  const { t: tCommon } = useTranslation("common");
  const { t: tActions } = useTranslation("actions");
  const { i18n } = useTranslation();

  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      // 1) 登录
      const cred = await signInWithEmailAndPassword(auth, email, password);
      const user = cred.user;

      // 2) 强制刷新，拿到最新的 emailVerified
      if (user) {
        await user.reload();
      }

      // 3) 未验证则登出+提示，并引导到 /verify-email
      if (!user || !user.emailVerified) {
        try {
          if (auth && auth.currentUser) {
            await auth.signOut();
          }
        } catch (signOutErr) {
          console.warn("signOut ignored in LoginForm:", signOutErr);
        }

        showAlert(
          tAuth("loginFailed"),
          tAuth("emailNotVerified"),
          tActions("ok") || "我知道了",
          "error",
          function () {
            navigate("/verify-email");
          }
        );
        return;
      }

      // 4) 已验证 → 进入 Dashboard
      navigate("/dashboard");
    } catch (err) {
      // ✅ 根据错误码选择对应 key
      let key = "errorDefault";
      if (err.code === "auth/user-not-found") {
        key = "errorUserNotFound";
      } else if (err.code === "auth/wrong-password") {
        key = "errorWrongPassword";
      } else if (err.code === "auth/invalid-credential") {
        key = "errorInvalidCredential";
      }

      showAlert(
        tAuth("loginFailed"),
        tCommon(key), // ✅ 用 key 取文案
        tActions("ok") || "我知道了",
        "error"
      );
    }
  };

  const handleLangToggle = () => {
    const newLang = i18n.language === "zh" ? "en" : "zh";
    // ✅ 优先使用父组件共用逻辑
    if (typeof switchLanguage === "function") {
      switchLanguage(newLang);
    } else {
      i18n.changeLanguage(newLang);
    }
  };

  return (
    <form onSubmit={handleLogin} className="auth-form">
      <label>
        {tAuth("email")}
        <input
          type="email"
          value={email}
          onChange={function (e) {
            setEmail(e.target.value);
          }}
          required
          placeholder={tAuth("emailPlaceholder")}
        />
      </label>

      <label>
        {tAuth("password")}
        <input
          type="password"
          value={password}
          onChange={function (e) {
            setPassword(e.target.value);
          }}
          required
          placeholder={tAuth("passwordPlaceholder")}
        />
      </label>

      <div className="login-actions">
        <button type="submit" className="action-button active">
          {i18n.language === "zh" ? "立即登录" : "Login Now"}
        </button>
        <button
          type="button"
          className="action-button inactive"
          onClick={handleLangToggle}
        >
          {i18n.language === "zh" ? "English" : "中文"}
        </button>
      </div>
    </form>
  );
}

export default LoginForm;
